// Mock data for Sialkot Gold Transport website
// Easy to edit - just modify the text, numbers, and URLs below

export const companyInfo = {
  name: "Sialkot Gold Transport & General Contracting L.L.C – S.P.C",
  shortName: "Sialkot Gold Transport",
  tagline: "Heavy Equipment Rental & Transport Services in Abu Dhabi",
  description: "Leading provider of heavy equipment rental and transport services in Abu Dhabi, UAE. We offer reliable, well-maintained machinery with skilled operators for construction, industrial, and commercial projects.",
  
  contact: {
    phones: [
      "+971545107215",
      "+971555561692",
      "+971502126872",
      "+971551482889"
    ],
    email: "sialkotgoldtransoprtngcllc@gmail.com",
    address: "Central Tower 20, Ras Al Qit'ah Street, M Floor, Office 44, Al Bateen, Abu Dhabi, UAE",
    shortAddress: "Al Bateen, Abu Dhabi, UAE",
    whatsapp: "+971545107215",
    googleMapsUrl: "https://www.google.com/maps/place/Sialkot+Gold+transport+and+general+contracting+LLC/@24.470496,54.341207,17z",
    googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3631.5!2d54.341207!3d24.470496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x75f8e2a6458e9542!2sSialkot%20Gold%20transport%20and%20general%20contracting%20LLC!5e0!3m2!1sen!2sae!4v123456789"
      }
};

export const equipment = [
  {
    id: 1,
    name: "Forklift",
    description: "High-capacity forklifts for warehouse, factory, and construction site operations. Available in various tonnage capacities.",
    image: "/images/image4.jpeg",
    features: ["Multiple capacity options", "Skilled operators included", "Daily/monthly rental", "Well-maintained fleet"]
  },
  {
    id: 2,
    name: "Excavator",
    description: "Heavy-duty excavators for digging, trenching, demolition, and earthmoving projects of all sizes.",
    image: "/images/pexels-photo-1078884.jpeg",
    features: ["Various sizes available", "Latest models", "Expert operators", "Flexible rental terms"]
  },
  {
    id: 3,
    name: "Bobcat / JCB",
    description: "Versatile compact loaders perfect for tight spaces, material handling, and multi-purpose construction tasks.",
    image: "/images/pexels-photo-416988.jpeg",
    features: ["Compact design", "Multi-purpose use", "Easy maneuverability", "Professional service"]
  },
  {
    id: 4,
    name: "Mobile Crane",
    description: "Heavy-duty mobile cranes for lifting and moving heavy materials and equipment on construction sites.",
    image: "/images/h6xktjdr_crane.jpg",
    features: ["High lifting capacity", "Certified operators", "Safety compliant", "Quick deployment"]
  },
  {
    id: 5,
    name: "Boom Loader",
    description: "Efficient boom loaders for material handling, loading, and construction site operations.",
    image: "/images/pexels-photo-1116035.jpeg",
    features: ["Extended reach", "Heavy load capacity", "Reliable performance", "Experienced crew"]
  },
  {
    id: 6,
    name: "Shovel Loader",
    description: "Powerful shovel loaders for earthmoving, material loading, and site preparation work.",
    image: "/images/pexels-photo-188679.jpeg",
    features: ["High efficiency", "Durable equipment", "Skilled operators", "Competitive rates"]
  },
  {
    id: 7,
    name: "Roza Bus",
    description: "Comfortable transport buses for worker transportation to and from construction sites and industrial areas.",
    image: "/images/u126ux8k_i6.png",
    features: ["Air-conditioned", "Multiple seating capacity", "Professional drivers", "Daily/monthly rental"]
  },
  {
    id: 8,
    name: "Pickup Truck",
    description: "Reliable pickup trucks for material transport, equipment delivery, and site supervision needs.",
    image: "/images/vmt312gw_image11.jpeg",
    features: ["Various models available", "4x4 capability", "Cargo capacity", "Flexible rental terms"]
  },
  {
    id: 9,
    name: "Tow Truck",
    description: "Professional tow trucks for vehicle recovery, heavy equipment transport, and emergency roadside assistance.",
    image: "/images/image5.jpeg",
    features: ["24/7 availability", "Heavy-duty towing", "Experienced operators", "Quick response time"]
  }
];

export const services = [
  {
    id: 1,
    title: "Heavy Equipment Rental",
    description: "Comprehensive fleet of heavy machinery available for short-term and long-term rental with professional operators.",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Forklift Services",
    description: "Wide range of forklifts for warehouse operations, loading/unloading, and material handling at factories and shops.",
    icon: "Package"
  },
  {
    id: 3,
    title: "Excavation Services",
    description: "Professional excavation and earthmoving services with modern excavators and experienced operators.",
    icon: "Construction"
  },
  {
    id: 4,
    title: "Crane Operations",
    description: "Mobile crane services for heavy lifting, material placement, and construction site operations.",
    icon: "Crane"
  },
  {
    id: 5,
    title: "Transport with Operator",
    description: "All equipment comes with skilled, licensed operators ensuring safe and efficient operation.",
    icon: "Users"
  },
  {
    id: 6,
    title: "Flexible Rental Terms",
    description: "Daily, weekly, and monthly rental options tailored to your project needs and budget.",
    icon: "Calendar"
  },
  {
    id: 7,
    title: "Worker Transport (Roza Bus)",
    description: "Comfortable air-conditioned buses for transporting workers to and from construction sites and industrial areas.",
    icon: "Bus"
  },
  {
    id: 8,
    title: "Pickup Truck Services",
    description: "Reliable pickup trucks for material transport, equipment delivery, and site supervision requirements.",
    icon: "Truck"
  },
  {
    id: 9,
    title: "Tow Truck Services",
    description: "24/7 professional towing services for vehicle recovery, heavy equipment transport, and emergency roadside assistance.",
    icon: "Truck"
  }
];

export const whyChooseUs = [
  {
    title: "Experienced & Reliable",
    description: "Years of experience serving construction and industrial sectors across Abu Dhabi and UAE."
  },
  {
    title: "Well-Maintained Fleet",
    description: "Regular maintenance and safety checks ensure optimal performance and reliability."
  },
  {
    title: "Skilled Operators",
    description: "All equipment comes with certified, experienced operators ensuring safe operations."
  },
  {
    title: "Competitive Pricing",
    description: "Transparent pricing with flexible rental terms to suit your project budget and timeline."
  },
  {
    title: "24/7 Support",
    description: "Round-the-clock customer support for emergencies and quick response times."
  },
  {
    title: "Safety First",
    description: "Strict adherence to safety standards and regulations for all our operations."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al Mansouri",
    company: "Al Mansouri Construction",
    text: "Excellent service and reliable equipment. Their team is professional and always on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mohammad Ali",
    company: "Emirates Industrial Solutions",
    text: "We've been using their forklifts for our warehouse operations for over a year. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Khalid Hassan",
    company: "Dubai Contracting LLC",
    text: "Professional operators and well-maintained machinery. Great value for money.",
    rating: 5
  }
];